var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"field-icon"},[_c('i',{class:_vm.customFieldIcon[_vm.field.inputType || _vm.field.identify] || 'iconfont icon-star-o'}),_c('div',[_vm._v(_vm._s(_vm.field.name))])])}
var staticRenderFns = []

export { render, staticRenderFns }